import { CR_API_ENDPOINTS } from '../constants';
import { apiService } from './api.service';
import { Conduit } from '../types';

class ConduitService {
  async getAllConduit(): Promise<Conduit[]> {
    try {
      return await apiService.get<Conduit[]>(CR_API_ENDPOINTS.CONDUIT);
    } catch (error) {
      throw new Error(`Failed to fetch conduit options: ${error}`);
    }
  }

  async getSizes(): Promise<Conduit[]> {
    try {
      return await apiService.get<Conduit[]>(CR_API_ENDPOINTS.CONDUIT_SIZES);
    } catch (error) {
      throw new Error(`Failed to fetch conduit sizes: ${error}`);
    }
  }

  async getTypes(): Promise<Conduit[]> {
    try {
      return await apiService.get<Conduit[]>(CR_API_ENDPOINTS.CONDUIT_TYPES);
    } catch (error) {
      throw new Error(`Failed to fetch conduit types: ${error}`);
    }
  }

  async getConduitById(id: string): Promise<Conduit> {
    try {
      return await apiService.get<Conduit>(`${CR_API_ENDPOINTS.CONDUIT}/${id}`);
    } catch (error) {
      throw new Error(`Failed to fetch conduit: ${error}`);
    }
  }

  async createConduit(conduitData: {
    category: string;
    value: string;
  }): Promise<Conduit> {
    try {
      return await apiService.post<Conduit>(CR_API_ENDPOINTS.CONDUIT, conduitData);
    } catch (error) {
      throw new Error(`Failed to create conduit: ${error}`);
    }
  }
}

export const conduitService = new ConduitService();